import * as r from "react";
import ve from "react";
import { s as L, r as ye, a as Me } from "./styled-38387a7e.js";
import { g as X, _ as b, a as _, p as e, b as G } from "./createTheme-02ce03eb.js";
import { j, c as A } from "./useTheme-efe1290c.js";
import { u as Le } from "./useTheme-d46e2483.js";
import { g as V, u as J, c as Q, a as te } from "./useThemeProps-ee4acb93.js";
import { g as Fe, M as Se } from "./Modal-fa620aff.js";
import { M as xe } from "./Paper-ea294db9.js";
import { o as ue } from "./ownerWindow-a0b5b7a5.js";
import { r as ke } from "./refType-e39501b1.js";
import { c as _e } from "./chainPropTypes-004bf492.js";
import { H as ee } from "./Portal-9153c320.js";
import { i as Ve } from "./integerPropType-e817878c.js";
import { e as ze } from "./elementTypeAcceptingRef-c7effbb1.js";
import { G as Ue } from "./Grow-473f264d.js";
import { o as Y } from "./ownerDocument-5430cd5b.js";
import { d as He } from "./debounce-c2e7efcb.js";
import { a as Te } from "./useEventCallback-fe4fd69c.js";
import { B as Ae } from "./ButtonBase-a4bd3410.js";
import "@emotion/styled";
import "@emotion/react";
import "./utils-55c3c65e.js";
import "./TransitionGroupContext-9484fef7.js";
import "react-dom";
import "./elementAcceptingRef-ad016689.js";
import "./useSlotProps-5893c531.js";
import "./useIsFocusVisible-4693b580.js";
const Pe = /* @__PURE__ */ r.createContext({});
process.env.NODE_ENV !== "production" && (Pe.displayName = "ListContext");
const oe = Pe;
function Be(o) {
  return X("MuiList", o);
}
V("MuiList", ["root", "padding", "dense", "subheader"]);
const Ke = ["children", "className", "component", "dense", "disablePadding", "subheader"], We = (o) => {
  const {
    classes: t,
    disablePadding: n,
    dense: i,
    subheader: f
  } = o;
  return Q({
    root: ["root", !n && "padding", i && "dense", f && "subheader"]
  }, Be, t);
}, Ge = L("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: n
    } = o;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: o
}) => b({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !o.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, o.subheader && {
  paddingTop: 0
})), Oe = /* @__PURE__ */ r.forwardRef(function(t, n) {
  const i = J({
    props: t,
    name: "MuiList"
  }), {
    children: f,
    className: d,
    component: l = "ul",
    dense: a = !1,
    disablePadding: c = !1,
    subheader: P
  } = i, I = _(i, Ke), N = r.useMemo(() => ({
    dense: a
  }), [a]), R = b({}, i, {
    component: l,
    dense: a,
    disablePadding: c
  }), u = We(R);
  return /* @__PURE__ */ j.jsx(oe.Provider, {
    value: N,
    children: /* @__PURE__ */ j.jsxs(Ge, b({
      as: l,
      className: A(u.root, d),
      ref: n,
      ownerState: R
    }, I, {
      children: [P, f]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Oe.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: e.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: e.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: e.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
const qe = Oe, Ye = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function Z(o, t, n) {
  return o === t ? o.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : o.firstChild;
}
function pe(o, t, n) {
  return o === t ? n ? o.firstChild : o.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : o.lastChild;
}
function Ce(o, t) {
  if (t === void 0)
    return !0;
  let n = o.innerText;
  return n === void 0 && (n = o.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function K(o, t, n, i, f, d) {
  let l = !1, a = f(o, t, t ? n : !1);
  for (; a; ) {
    if (a === o.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const c = i ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !Ce(a, d) || c)
      a = f(o, a, n);
    else
      return a.focus(), !0;
  }
  return !1;
}
const Ee = /* @__PURE__ */ r.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: i,
    autoFocus: f = !1,
    autoFocusItem: d = !1,
    children: l,
    className: a,
    disabledItemsFocusable: c = !1,
    disableListWrap: P = !1,
    onKeyDown: I,
    variant: N = "selectedMenu"
  } = t, R = _(t, Ye), u = r.useRef(null), v = r.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Te(() => {
    f && u.current.focus();
  }, [f]), r.useImperativeHandle(i, () => ({
    adjustStyleForScrollbar: (s, p) => {
      const M = !u.current.style.width;
      if (s.clientHeight < u.current.clientHeight && M) {
        const x = `${Fe(Y(s))}px`;
        u.current.style[p.direction === "rtl" ? "paddingLeft" : "paddingRight"] = x, u.current.style.width = `calc(100% + ${x})`;
      }
      return u.current;
    }
  }), []);
  const O = (s) => {
    const p = u.current, M = s.key, x = Y(p).activeElement;
    if (M === "ArrowDown")
      s.preventDefault(), K(p, x, P, c, Z);
    else if (M === "ArrowUp")
      s.preventDefault(), K(p, x, P, c, pe);
    else if (M === "Home")
      s.preventDefault(), K(p, null, P, c, Z);
    else if (M === "End")
      s.preventDefault(), K(p, null, P, c, pe);
    else if (M.length === 1) {
      const g = v.current, F = M.toLowerCase(), D = performance.now();
      g.keys.length > 0 && (D - g.lastTime > 500 ? (g.keys = [], g.repeating = !0, g.previousKeyMatched = !0) : g.repeating && F !== g.keys[0] && (g.repeating = !1)), g.lastTime = D, g.keys.push(F);
      const T = x && !g.repeating && Ce(x, g);
      g.previousKeyMatched && (T || K(p, x, !1, c, Z, g)) ? s.preventDefault() : g.previousKeyMatched = !1;
    }
    I && I(s);
  }, C = te(u, n);
  let y = -1;
  r.Children.forEach(l, (s, p) => {
    /* @__PURE__ */ r.isValidElement(s) && (process.env.NODE_ENV !== "production" && ye.isFragment(s) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), s.props.disabled || (N === "selectedMenu" && s.props.selected || y === -1) && (y = p), y === p && (s.props.disabled || s.props.muiSkipListHighlight || s.type.muiSkipListHighlight) && (y += 1, y >= l.length && (y = -1)));
  });
  const w = r.Children.map(l, (s, p) => {
    if (p === y) {
      const M = {};
      return d && (M.autoFocus = !0), s.props.tabIndex === void 0 && N === "selectedMenu" && (M.tabIndex = 0), /* @__PURE__ */ r.cloneElement(s, M);
    }
    return s;
  });
  return /* @__PURE__ */ j.jsx(qe, b({
    role: "menu",
    ref: C,
    className: a,
    onKeyDown: O,
    tabIndex: f ? 0 : -1
  }, R, {
    children: w
  }));
});
process.env.NODE_ENV !== "production" && (Ee.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: e.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: e.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: e.node,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: e.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: e.bool,
  /**
   * @ignore
   */
  onKeyDown: e.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: e.oneOf(["menu", "selectedMenu"])
});
const Xe = Ee;
function Je(o) {
  return X("MuiPopover", o);
}
V("MuiPopover", ["root", "paper"]);
const Qe = ["onEntering"], Ze = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
function de(o, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = o.height / 2 : t === "bottom" && (n = o.height), n;
}
function fe(o, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = o.width / 2 : t === "right" && (n = o.width), n;
}
function me(o) {
  return [o.horizontal, o.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function q(o) {
  return typeof o == "function" ? o() : o;
}
const eo = (o) => {
  const {
    classes: t
  } = o;
  return Q({
    root: ["root"],
    paper: ["paper"]
  }, Je, t);
}, oo = L(Se, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (o, t) => t.root
})({}), to = L(xe, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (o, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Ie = /* @__PURE__ */ r.forwardRef(function(t, n) {
  const i = J({
    props: t,
    name: "MuiPopover"
  }), {
    action: f,
    anchorEl: d,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: a,
    anchorReference: c = "anchorEl",
    children: P,
    className: I,
    container: N,
    elevation: R = 8,
    marginThreshold: u = 16,
    open: v,
    PaperProps: O = {},
    transformOrigin: C = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: y = Ue,
    transitionDuration: w = "auto",
    TransitionProps: {
      onEntering: s
    } = {}
  } = i, p = _(i.TransitionProps, Qe), M = _(i, Ze), x = r.useRef(), g = te(x, O.ref), F = b({}, i, {
    anchorOrigin: l,
    anchorReference: c,
    elevation: R,
    marginThreshold: u,
    PaperProps: O,
    transformOrigin: C,
    TransitionComponent: y,
    transitionDuration: w,
    TransitionProps: p
  }), D = eo(F), T = r.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (a || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), a;
    const m = q(d), h = m && m.nodeType === 1 ? m : Y(x.current).body, E = h.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const k = h.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && k.top === 0 && k.left === 0 && k.right === 0 && k.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: E.top + de(E, l.vertical),
      left: E.left + fe(E, l.horizontal)
    };
  }, [d, l.horizontal, l.vertical, a, c]), S = r.useCallback((m) => ({
    vertical: de(m, C.vertical),
    horizontal: fe(m, C.horizontal)
  }), [C.horizontal, C.vertical]), ne = r.useCallback((m) => {
    const h = {
      width: m.offsetWidth,
      height: m.offsetHeight
    }, E = S(h);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: me(E)
      };
    const k = T();
    let U = k.top - E.vertical, H = k.left - E.horizontal;
    const ie = U + h.height, ae = H + h.width, le = ue(q(d)), B = le.innerHeight - u, ce = le.innerWidth - u;
    if (U < u) {
      const $ = U - u;
      U -= $, E.vertical += $;
    } else if (ie > B) {
      const $ = ie - B;
      U -= $, E.vertical += $;
    }
    if (process.env.NODE_ENV !== "production" && h.height > B && h.height && B && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${h.height - B}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), H < u) {
      const $ = H - u;
      H -= $, E.horizontal += $;
    } else if (ae > ce) {
      const $ = ae - ce;
      H -= $, E.horizontal += $;
    }
    return {
      top: `${Math.round(U)}px`,
      left: `${Math.round(H)}px`,
      transformOrigin: me(E)
    };
  }, [d, c, T, S, u]), [Ne, se] = r.useState(v), z = r.useCallback(() => {
    const m = x.current;
    if (!m)
      return;
    const h = ne(m);
    h.top !== null && (m.style.top = h.top), h.left !== null && (m.style.left = h.left), m.style.transformOrigin = h.transformOrigin, se(!0);
  }, [ne]), $e = (m, h) => {
    s && s(m, h), z();
  }, De = () => {
    se(!1);
  };
  r.useEffect(() => {
    v && z();
  }), r.useImperativeHandle(f, () => v ? {
    updatePosition: () => {
      z();
    }
  } : null, [v, z]), r.useEffect(() => {
    if (!v)
      return;
    const m = He(() => {
      z();
    }), h = ue(d);
    return h.addEventListener("resize", m), () => {
      m.clear(), h.removeEventListener("resize", m);
    };
  }, [d, v, z]);
  let re = w;
  w === "auto" && !y.muiSupportAuto && (re = void 0);
  const je = N || (d ? Y(q(d)).body : void 0);
  return /* @__PURE__ */ j.jsx(oo, b({
    BackdropProps: {
      invisible: !0
    },
    className: A(D.root, I),
    container: je,
    open: v,
    ref: n,
    ownerState: F
  }, M, {
    children: /* @__PURE__ */ j.jsx(y, b({
      appear: !0,
      in: v,
      onEntering: $e,
      onExited: De,
      timeout: re
    }, p, {
      children: /* @__PURE__ */ j.jsx(to, b({
        elevation: R
      }, O, {
        ref: g,
        className: A(D.paper, O.className)
      }, Ne ? void 0 : {
        style: b({}, O.style, {
          opacity: 0
        })
      }, {
        ownerState: F,
        children: P
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Ie.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: ke,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the popover.
   */
  anchorEl: _e(e.oneOfType([ee, e.func]), (o) => {
    if (o.open && (!o.anchorReference || o.anchorReference === "anchorEl")) {
      const t = q(o.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: e.shape({
    horizontal: e.oneOfType([e.oneOf(["center", "left", "right"]), e.number]).isRequired,
    vertical: e.oneOfType([e.oneOf(["bottom", "center", "top"]), e.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: e.shape({
    left: e.number.isRequired,
    top: e.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: e.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: e.oneOfType([ee, e.func]),
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Ve,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * @default 16
   */
  marginThreshold: e.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: e.shape({
    component: ze
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: e.shape({
    horizontal: e.oneOfType([e.oneOf(["center", "left", "right"]), e.number]).isRequired,
    vertical: e.oneOfType([e.oneOf(["bottom", "center", "top"]), e.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: e.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: e.oneOfType([e.oneOf(["auto"]), e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: e.object
});
const no = Ie;
function so(o) {
  return X("MuiMenu", o);
}
V("MuiMenu", ["root", "paper", "list"]);
const ro = ["onEntering"], io = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"], ao = {
  vertical: "top",
  horizontal: "right"
}, lo = {
  vertical: "top",
  horizontal: "left"
}, co = (o) => {
  const {
    classes: t
  } = o;
  return Q({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, so, t);
}, uo = L(no, {
  shouldForwardProp: (o) => Me(o) || o === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (o, t) => t.root
})({}), po = L(xe, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (o, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tapable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), fo = L(Xe, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (o, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Re = /* @__PURE__ */ r.forwardRef(function(t, n) {
  const i = J({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: f = !0,
    children: d,
    disableAutoFocusItem: l = !1,
    MenuListProps: a = {},
    onClose: c,
    open: P,
    PaperProps: I = {},
    PopoverClasses: N,
    transitionDuration: R = "auto",
    TransitionProps: {
      onEntering: u
    } = {},
    variant: v = "selectedMenu"
  } = i, O = _(i.TransitionProps, ro), C = _(i, io), y = Le(), w = y.direction === "rtl", s = b({}, i, {
    autoFocus: f,
    disableAutoFocusItem: l,
    MenuListProps: a,
    onEntering: u,
    PaperProps: I,
    transitionDuration: R,
    TransitionProps: O,
    variant: v
  }), p = co(s), M = f && !l && P, x = r.useRef(null), g = (T, S) => {
    x.current && x.current.adjustStyleForScrollbar(T, y), u && u(T, S);
  }, F = (T) => {
    T.key === "Tab" && (T.preventDefault(), c && c(T, "tabKeyDown"));
  };
  let D = -1;
  return r.Children.map(d, (T, S) => {
    /* @__PURE__ */ r.isValidElement(T) && (process.env.NODE_ENV !== "production" && ye.isFragment(T) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), T.props.disabled || (v === "selectedMenu" && T.props.selected || D === -1) && (D = S));
  }), /* @__PURE__ */ j.jsx(uo, b({
    onClose: c,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: w ? "right" : "left"
    },
    transformOrigin: w ? ao : lo,
    PaperProps: b({
      as: po
    }, I, {
      classes: b({}, I.classes, {
        root: p.paper
      })
    }),
    className: p.root,
    open: P,
    ref: n,
    transitionDuration: R,
    TransitionProps: b({
      onEntering: g
    }, O),
    ownerState: s
  }, C, {
    classes: N,
    children: /* @__PURE__ */ j.jsx(fo, b({
      onKeyDown: F,
      actions: x,
      autoFocus: f && (D === -1 || l),
      autoFocusItem: M,
      variant: v
    }, a, {
      className: A(p.list, a.className),
      children: d
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Re.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: e.oneOfType([ee, e.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: e.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: e.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: e.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: e.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: e.oneOfType([e.oneOf(["auto"]), e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: e.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: e.oneOf(["menu", "selectedMenu"])
});
const mo = Re, et = L(ho)(() => ({}));
function ho(o) {
  return /* @__PURE__ */ ve.createElement(mo, { ...o });
}
const bo = V("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), he = bo, go = V("MuiListItemIcon", ["root", "alignItemsFlexStart"]), be = go, vo = V("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), ge = vo;
function yo(o) {
  return X("MuiMenuItem", o);
}
const Mo = V("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), W = Mo, xo = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], To = (o, t) => {
  const {
    ownerState: n
  } = o;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, Po = (o) => {
  const {
    disabled: t,
    dense: n,
    divider: i,
    disableGutters: f,
    selected: d,
    classes: l
  } = o, c = Q({
    root: ["root", n && "dense", t && "disabled", !f && "gutters", i && "divider", d && "selected"]
  }, yo, l);
  return b({}, l, c);
}, Oo = L(Ae, {
  shouldForwardProp: (o) => Me(o) || o === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: To
})(({
  theme: o,
  ownerState: t
}) => b({}, o.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(o.vars || o).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (o.vars || o).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${W.selected}`]: {
    backgroundColor: o.vars ? `rgba(${o.vars.palette.primary.mainChannel} / ${o.vars.palette.action.selectedOpacity})` : G(o.palette.primary.main, o.palette.action.selectedOpacity),
    [`&.${W.focusVisible}`]: {
      backgroundColor: o.vars ? `rgba(${o.vars.palette.primary.mainChannel} / calc(${o.vars.palette.action.selectedOpacity} + ${o.vars.palette.action.focusOpacity}))` : G(o.palette.primary.main, o.palette.action.selectedOpacity + o.palette.action.focusOpacity)
    }
  },
  [`&.${W.selected}:hover`]: {
    backgroundColor: o.vars ? `rgba(${o.vars.palette.primary.mainChannel} / calc(${o.vars.palette.action.selectedOpacity} + ${o.vars.palette.action.hoverOpacity}))` : G(o.palette.primary.main, o.palette.action.selectedOpacity + o.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: o.vars ? `rgba(${o.vars.palette.primary.mainChannel} / ${o.vars.palette.action.selectedOpacity})` : G(o.palette.primary.main, o.palette.action.selectedOpacity)
    }
  },
  [`&.${W.focusVisible}`]: {
    backgroundColor: (o.vars || o).palette.action.focus
  },
  [`&.${W.disabled}`]: {
    opacity: (o.vars || o).palette.action.disabledOpacity
  },
  [`& + .${he.root}`]: {
    marginTop: o.spacing(1),
    marginBottom: o.spacing(1)
  },
  [`& + .${he.inset}`]: {
    marginLeft: 52
  },
  [`& .${ge.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${ge.inset}`]: {
    paddingLeft: 36
  },
  [`& .${be.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [o.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && b({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, o.typography.body2, {
  [`& .${be.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), we = /* @__PURE__ */ r.forwardRef(function(t, n) {
  const i = J({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: f = !1,
    component: d = "li",
    dense: l = !1,
    divider: a = !1,
    disableGutters: c = !1,
    focusVisibleClassName: P,
    role: I = "menuitem",
    tabIndex: N,
    className: R
  } = i, u = _(i, xo), v = r.useContext(oe), O = r.useMemo(() => ({
    dense: l || v.dense || !1,
    disableGutters: c
  }), [v.dense, l, c]), C = r.useRef(null);
  Te(() => {
    f && (C.current ? C.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [f]);
  const y = b({}, i, {
    dense: O.dense,
    divider: a,
    disableGutters: c
  }), w = Po(i), s = te(C, n);
  let p;
  return i.disabled || (p = N !== void 0 ? N : -1), /* @__PURE__ */ j.jsx(oe.Provider, {
    value: O,
    children: /* @__PURE__ */ j.jsx(Oo, b({
      ref: s,
      role: I,
      tabIndex: p,
      component: d,
      focusVisibleClassName: A(w.focusVisible, P),
      className: A(w.root, R)
    }, u, {
      ownerState: y,
      classes: w
    }))
  });
});
process.env.NODE_ENV !== "production" && (we.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: e.bool,
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: e.bool,
  /**
   * @ignore
   */
  disabled: e.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: e.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: e.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: e.string,
  /**
   * @ignore
   */
  role: e.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: e.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * @default 0
   */
  tabIndex: e.number
});
const Co = we, ot = L(Eo)(() => ({}));
function Eo(o) {
  return /* @__PURE__ */ ve.createElement(Co, { ...o });
}
export {
  et as MzMenu,
  ot as MzMenuItem
};
